import { observer } from 'mobx-react-lite';
import { useSwiper } from 'swiper/react';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';

export const SwiperNavigations: FC = observer(() => {
    const swiper = useSwiper();
    const dialogService = useService(DialogService);
    const { redeemDialogSrv } = dialogService;

    return (
        <div className="redeem-amounts-arrows">
            <div className="redeem-amounts-arrow-left">
                <a
                    className="redeem-slide-prev"
                    onClick={e => {
                        e.preventDefault();
                        swiper.slidePrev();
                    }}
                    href="#"
                >
                    <figure>
                        {redeemDialogSrv.slideArrowLeftEnabled && (
                            <img id="redeem-arrow-left" src="/assets/img/redeem-arrow-left.svg" />
                        )}
                        {!redeemDialogSrv.slideArrowLeftEnabled && (
                            <img id="redeem-arrow-left-disabled" src="/assets/img/redeem-arrow-left-disabled.svg" />
                        )}
                    </figure>
                </a>
            </div>
            <div className="redeem-amounts-arrow-right">
                <a
                    className="redeem-slide-next"
                    href="#"
                    onClick={e => {
                        e.preventDefault();
                        swiper.slideNext();
                    }}
                >
                    <figure>
                        {redeemDialogSrv.slideArrowRightEnabled && (
                            <img id="redeem-arrow-right" src="/assets/img/redeem-arrow-right.svg" />
                        )}
                        {!redeemDialogSrv.slideArrowRightEnabled && (
                            <img id="redeem-arrow-right-disabled" src="/assets/img/redeem-arrow-right-disabled.svg" />
                        )}
                    </figure>
                </a>
            </div>
        </div>
    );
});
